<script lang="ts" setup>
import { staffServices } from '@/api/staff'

type SelectRaw = string | number
type SelectValue = SelectRaw | SelectRaw[] | undefined

const props = defineProps({
  placeholder: {
    type: String,
    default: 'Chọn nhân viên',
  },
  isMultiSelect: {
    type: Boolean,
    default: false,
  },
  orgUnitIds: {
    type: Array<number>,
    default: () => [],
  },
  orgUnitId: {
    type: [Number, null],
    default: null,
  },

  disabled: {
    type: Boolean,
    default: false,
  },
  status: {
    type: [Number, null],
    default: null,
  },
  isCustomFilterByStatus: {
    type: Boolean,
    default: false,
  },
  autoSelect: {
    type: String,
    default: '', // 'all', 'first', ''
    validator: (value: string) => ['', 'all', 'first'].includes(value),
  },
  allowSelect: {
    type: Boolean,
    default: false,
  },
})
const val = defineModel<SelectValue>({
  default: '',
})
const staffList = defineModel('staffList', {
  type: Array,
  default: () => [],
})
// Loading state khi gọi API
const loading = ref(false)
// Danh sách nhân viên trả về từ API
const data = ref([])
// Gán danh sách nhân viên đã chọn cho val model
const onChange = (value: any) => {
  val.value = value
}
const autoFillValue = () => {
  if (props.autoSelect === 'all' && data.value.length > 0) {
    if (props.isMultiSelect) {
      val.value = data.value.map((item: any) => item.value)
    } else {
      val.value = data.value[0]?.value
    }
  } else if (props.autoSelect === 'first' && data.value.length > 0) {
    val.value = data.value[0]?.value
  }
}

// Hàm lấy dữ liệu nhân viên từ API
const getData = async () => {
  if ((props.orgUnitIds && props.orgUnitIds.length > 0) || props.orgUnitId) {
    loading.value = true
    data.value = []
    const orgUnitIdToUse =
      props.orgUnitIds && props.orgUnitIds.length > 0 ? props.orgUnitIds : props.orgUnitId
    const filters = {
      exStaffIds: val.value || [],
      orgUnitId: orgUnitIdToUse,
      status: props.status,
      pageInfo: {
        currentPage: 0,
        pageSize: 500,
      },
    } //@todo: cần áp dụng scroll

    const { body } = await staffServices.searchOrgUnitId(filters)
    data.value = (body.result || [])
      .map((item: any) => {
        return {
          label: item.staffName,
          value: item.staffId,
          disabled: props.isCustomFilterByStatus ? !item.staffStatus : false,
          staffCode: item.staffCode,
          staffName: item.staffName,
          staffId: item.staffId,
          staffEmail: item.email,
        }
      })
      .filter(item =>
        props.isCustomFilterByStatus ? !item.disabled || val?.value?.includes(item.value) : true
      )
      .filter((item, index, self) => index === self.findIndex(other => other.value === item.value))

    loading.value = false

    if (props.allowSelect) {
      autoFillValue()
    }
  } else {
    data.value = []
  }
  console.log('data.value', data.value)
  staffList.value = data.value
}

const filterOption = (input: string, option: any) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
// watchEffect(async () => {
//   if (props.orgUnitIds && props.orgUnitIds.length > 0 ) {
//     await getData()
//   } else {
//     data.value = []
//   }
// })

watch(
  [() => props.orgUnitIds, () => props.orgUnitId],
  async (newValues, oldValues) => {
    const [newOrgUnitIds, newOrgUnitId] = newValues
    const [oldOrgUnitIds, oldOrgUnitId] = oldValues

    // Kiểm tra xem có thay đổi thực sự không
    const hasOrgUnitIdsChanged = JSON.stringify(newOrgUnitIds) !== JSON.stringify(oldOrgUnitIds)
    const hasOrgUnitIdChanged = newOrgUnitId !== oldOrgUnitId

    if (hasOrgUnitIdsChanged || hasOrgUnitIdChanged) {
      if ((newOrgUnitIds && newOrgUnitIds.length > 0) || newOrgUnitId) {
        await getData()
      } else {
        data.value = []
        staffList.value = []
      }
    }
  },
  { immediate: true }
)
</script>
<template>
  <a-select
    v-model:value="val"
    allow-clear
    show-search
    :filter-option="filterOption"
    :disabled="disabled"
    :options="data"
    :loading="loading"
    :mode="isMultiSelect ? 'multiple' : undefined"
    :placeholder="placeholder"
    :not-found-content="null"
    @change="onChange"
  />
</template>
